import { createContext, useContext } from 'react';

const PageLayoutContext = createContext();

export const usePageLayoutContext = () => useContext(PageLayoutContext);

export default PageLayoutContext;
